import { useQuery } from '@apollo/client';
import { COMMON_CONSTANTS, Loader } from '@nile/components';
import {
  GET_ENTITY_PROPERTIES,
  GET_RULEBUILDER_OPERATORS,
  GET_TICKET_LISTVIEW_META
} from '@nile/graphql';
import {
  onAttributeSelect,
  onValueSearch
} from '@nile/components/src/Pebbles/AdvancedTicketFilter';
import AdvancedFilter from '@nile/components/src/Components/AdvancedFilter';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';

function AdvancedTicketFilter(props) {
  const { updateCondition, conditions, iconOnly } = props;
  const {
    loading: ticketListViewMetaLoading,
    error: ticketAutomationError,
    data: ticketListViewMeta
  } = useQuery(GET_TICKET_LISTVIEW_META, {
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE
  });
  if (ticketListViewMetaLoading) return <Loader />;
  if (ticketAutomationError) return <div>error...</div>;
  const conditionsForAdvancedSearch = conditions;
  return (
    <div>
      <AdvancedFilter
        listMeta={ticketListViewMeta.getTicketListViewMetaInfo}
        currentModule="ticket"
        conditions={conditionsForAdvancedSearch}
        onAttributeSelect={onAttributeSelect}
        onValueSearch={onValueSearch}
        updateCondition={updateCondition}
        iconOnly={iconOnly}
      />
    </div>
  );
}

export default AdvancedTicketFilter;
